import React from 'react';
import { CircledLabelStyled } from './circled-label.component.style';
export var CircledLabel = function (_a) {
    var label = _a.label, _b = _a.size, size = _b === void 0 ? 'medium' : _b;
    return (React.createElement(CircledLabelStyled, { size: size }, label));
};
